import Modal from '../../components/ui/Modal';
import CommentsPanel from './CommentsPanel';

/**
 * Comments in a dialog (opened from file/folder rows). The actual experience
 * lives in CommentsPanel, shared with the file viewer's conversation sidebar.
 * Modal returns null when closed, so the panel (and its queries) only mount
 * while the dialog is open.
 */
export default function CommentsModal({ open, onClose, target }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={target ? `Comments — ${target.item.name}` : 'Comments'}
    >
      <CommentsPanel targetType={target?.type} targetId={target?.item?.id} />
    </Modal>
  );
}
